import { httpInstance } from '@/services/httpInstance';

const updateProvinces = async (dataParam) => {
  let res;
  const endpoint = '/frontlabels/v1/addresses/provinces';
  const dataSent = dataParam;

  await httpInstance.put(
    endpoint,
    dataSent,
  ).then((data) => {
    res = data;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default updateProvinces;
